(function () {
  'use strict';

  const root = document.querySelector('[data-cabinfix-root]');

  function selectModel(model) {
    document.querySelectorAll('[data-model-button]').forEach((button) => {
      button.classList.toggle('selected', button.dataset.modelButton === model);
      button.setAttribute('aria-pressed', button.dataset.modelButton === model ? 'true' : 'false');
    });
    document.querySelectorAll('[data-product-panel]').forEach((panel) => {
      panel.classList.toggle('is-hidden', panel.dataset.productPanel !== model);
    });
    document.querySelectorAll('[data-model-content]').forEach((panel) => {
      panel.classList.toggle('is-hidden', panel.dataset.modelContent !== model);
    });
    document.querySelectorAll('[data-fitment-panel]').forEach((panel) => {
      panel.classList.toggle('is-hidden', panel.dataset.fitmentPanel !== model);
    });
    const mobileModel = document.querySelector('[data-mobile-model]');
    if (mobileModel) mobileModel.textContent = model === 'e90' ? 'E90-E93' : 'E60 / E61';
    const mobileLink = document.querySelector('[data-mobile-buy-link]');
    if (mobileLink) mobileLink.href = model === 'e90' ? '#produktas-e90' : '#produktas-e60';
  }

  function setupGallery(gallery) {
    const main = gallery.querySelector('[data-gallery-main]');
    const count = gallery.querySelector('[data-gallery-count]');
    const allThumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    let activeIndex = 0;
    let touchStartX = 0;

    function visibleThumbs() {
      return allThumbs.filter((thumb) => !thumb.hidden);
    }

    function show(thumb) {
      const thumbs = visibleThumbs();
      if (!thumb || !thumbs.length) return;
      allThumbs.forEach((item) => item.classList.toggle('active', item === thumb));
      main.src = thumb.dataset.src;
      main.alt = thumb.dataset.alt || '';
      activeIndex = thumbs.indexOf(thumb);
      if (count) count.textContent = `${activeIndex + 1} / ${thumbs.length}`;
    }

    function move(direction) {
      const thumbs = visibleThumbs();
      if (!thumbs.length) return;
      activeIndex = (activeIndex + direction + thumbs.length) % thumbs.length;
      show(thumbs[activeIndex]);
    }

    allThumbs.forEach((thumb) => thumb.addEventListener('click', () => show(thumb)));
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => move(-1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => move(1));

    main.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0].screenX;
    }, { passive: true });
    main.addEventListener('touchend', (event) => {
      const distance = event.changedTouches[0].screenX - touchStartX;
      if (Math.abs(distance) > 45) move(distance > 0 ? -1 : 1);
    }, { passive: true });

    gallery.cabinFixFilter = function (kind) {
      allThumbs.forEach((thumb) => {
        thumb.hidden = kind !== 'pair' && thumb.dataset.side !== kind;
      });
      show(visibleThumbs()[0]);
    };
  }

  function setupProductPanel(panel) {
    const gallery = panel.querySelector('[data-product-gallery]');
    if (gallery) setupGallery(gallery);

    const form = panel.querySelector('.product-form');
    if (!form) return;
    const hiddenId = form.querySelector('[data-variant-id]');
    const price = form.querySelector('[data-current-price]');
    const title = form.querySelector('[data-selected-title]');
    const shipping = form.querySelector('[data-shipping-note]');

    form.querySelectorAll('[data-variant-radio]').forEach((radio) => {
      radio.addEventListener('change', () => {
        hiddenId.value = radio.value;
        if (price) price.textContent = radio.dataset.price;
        if (title) title.textContent = radio.dataset.title;
        if (shipping) shipping.textContent = radio.dataset.kind === 'pair'
          ? 'Nemokamas pristatymas'
          : 'Pristatymas Lietuvoje - 3,99 €';
        if (gallery?.cabinFixFilter) gallery.cabinFixFilter(radio.dataset.kind);
      });
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('[data-add-to-cart]');
      if (button) button.disabled = true;
      try {
        const response = await fetch(`${window.cabinFixRoutes.cartAdd}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Cart request failed');
        const item = await response.json();
        const cartResponse = await fetch(window.cabinFixRoutes.cartJson, { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
        const toast = document.querySelector('[data-cart-toast]');
        if (toast) {
          const toastText = toast.querySelector('[data-cart-toast-text]');
          if (toastText) toastText.textContent = item.product_title || 'Prekė įdėta į krepšelį';
          toast.hidden = false;
          window.setTimeout(() => { toast.hidden = true; }, 4500);
        }
      } catch (error) {
        form.submit();
      } finally {
        if (button) button.disabled = false;
      }
    });
  }

  document.querySelectorAll('[data-language-select]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });

  document.querySelectorAll('[data-model-button]').forEach((button) => {
    button.addEventListener('click', () => selectModel(button.dataset.modelButton));
  });

  document.querySelectorAll('[data-product-panel]').forEach(setupProductPanel);
  if (root) selectModel('e60');
})();
